export default {
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    error: {
      type: Object
    },
    isFormSubmitted: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.localValue = this.value
  },
  data: () => ({
    localValue: ''
  }),
  watch: {
    localValue (value) {
      this.$emit('input', value)
    }
  },
  components: {
    FormError: () => import('@/components/form/Error')
  }
}
